import { ReactNode, useState } from "react";
import { LinkOffOutlined, LinkOutlined } from "@mui/icons-material";
import useCarrierServiceList from "$hooks/useCarrierServiceList";
import { Table, Text } from "$components";
import { CarrierService } from "$types";
import { ACTIVITIES_LABELS } from "$utils/typeConstants";
import useJStyles from "$hooks/useJStyles";
import { theme } from "$utils/theme/bataillog";
import ShippingConfigPopin from "./ShippingConfigPopin";

enum ERROR_MSG {
  NO_CARRIER = "Aucun service de livraison n'a été trouvé",
  NO_RESULTS = "Aucun résultat ne correspond à votre recherche",
  LOADING = "Chargement en cours",
}

function ShippingConfigList() {
  const { jclasses } = useJStyles();
  const { carrierServices, fetchCarrierServices, isFetching } =
    useCarrierServiceList();
  const [selectedCarrierService, selectCarrierService] =
    useState<CarrierService | null>(null);
  const [isPopinOpen, togglePopin] = useState<boolean>(false);

  const onDrawerSubmit = () => {
    togglePopin(false);
    fetchCarrierServices();
  };

  const bodyTable = carrierServices?.map((carrierService) => {
    const renderCell = (value: ReactNode) => ({
      onClickAction: () => {
        selectCarrierService(carrierService);
        togglePopin(true);
      },
      value,
    });

    return [
      renderCell(
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={carrierService.carrierLogo}
            alt={carrierService.carrierName}
            style={{ height: 40, margin: "4px 16px 4px 0" }}
          />
          <Text>{`${carrierService.carrierName} ${carrierService.label} (${carrierService.serviceName})`}</Text>
        </div>
      ),
      renderCell(<Text>{carrierService.connector || "N/A"}</Text>),
      renderCell(<Text>{carrierService.company?.name || "N/A"}</Text>),
      renderCell(
        <Text>
          {ACTIVITIES_LABELS[carrierService.carrierActivity] || "N/A"}
        </Text>
      ),
      renderCell(
        carrierService.company?.name ? (
          <LinkOffOutlined style={{ color: theme.color.blueLight }} />
        ) : (
          <LinkOutlined style={{ color: theme.color.blueLight }} />
        )
      ),
    ];
  });

  const tHeadFilters = [
    { id: "carrier-service", label: "Service de livraison" },
    { id: "connector", label: "Connecteur" },
    { id: "attached-agency", label: "Agence rattachée" },
    { id: "attached-agency-service", label: "Service d'agence rattaché" },
    { id: "is-attached", label: "" },
  ];

  return (
    <>
      {/* Relative for the no results placeholder */}
      <div style={{ position: "relative" }}>
        <Table
          bodyData={bodyTable}
          rowsPerPage={50}
          thead={tHeadFilters}
          pageName="ShippingConfigList"
          usePaper={false}
          load={isFetching}
        />
        {!bodyTable?.length && (
          <div className={jclasses.jNoResultPlaceHolder}>
            {!isFetching && !bodyTable?.length && (
              <Text type="h3">
                {carrierServices?.length
                  ? ERROR_MSG.NO_RESULTS
                  : ERROR_MSG.NO_CARRIER}
              </Text>
            )}
          </div>
        )}

        <ShippingConfigPopin
          isOpen={isPopinOpen}
          onSubmit={onDrawerSubmit}
          onClose={() => togglePopin(false)}
          carrierServiceId={selectedCarrierService?.id}
        />
      </div>
    </>
  );
}

export default ShippingConfigList;
